import { accessTokenUri } from '../utils/oauthConfig'

const getAccessToken = (code, providerType, redirectUri) => {
    const params = {
        code: code,
        provider: providerType,
        redirectUri: redirectUri
    }
    const paramString = Object.keys(params).map(key => `${key}=${params[key]}`).join("&")
    return fetch(`${accessTokenUri}?${paramString}`)
        .then(response => {
            if (response.status < 400) {
                return response.json()
            } else {
                throw response.json()
            }
        })
        .catch(error => {
            throw error
        })
}

export { getAccessToken }